import React from 'react'
import { avecClient, estPageClient } from '../lib/clientAffiche'

/**
 * Spec 160 — le client affiché, tel que la coquille l'a résolu (`resoudreClientAffiche`), pour les liens qu'un
 * composant construit sans recevoir le client en propriété (menu, blocs du tableau de bord, recherche…).
 *
 * Les pages continuent de lire `{ selectedAccountId, clientViewMode }` par le contexte de route : ce contexte-ci ne
 * sert qu'à **emporter le client dans les liens** (research D-160-03).
 */
export interface ClientAfficheValue {
  accountId: string | null
  vueClient: boolean
}

export const ClientAfficheContext = React.createContext<ClientAfficheValue>({ accountId: null, vueClient: false })

/**
 * Lien interne qui emporte le client affiché (et la Vue client) quand il mène à une page client ; inchangé sinon.
 *
 * C'est ce qui garde le client d'un onglet quand on ouvre un lien dans un nouvel onglet, et ce qui évite à la coquille
 * de compléter l'adresse après coup — le SDK de télémétrie compterait alors une vue de page de plus.
 */
export function useLienClient(): (chemin: string) => string {
  const { accountId, vueClient } = React.useContext(ClientAfficheContext)
  return React.useCallback((chemin: string) => {
    if (!accountId) return chemin
    const pathname = new URL(chemin, 'http://portail.local').pathname
    return estPageClient(pathname) ? avecClient(chemin, accountId, vueClient) : chemin
  }, [accountId, vueClient])
}
